export default "__VITE_ASSET__CiUV2ZIF__"